import React, { Component } from 'react'
import { changeEventsModal, resetInvitationsPusher } from 'src/actions/event'
import { connect } from 'react-redux'
import { EMAIL_CONTACT_METHOD } from 'src/services/contact_methods'
import {
  eventSelector,
  activeInvitationsSelector,
  isHostSelector,
  isHostOrCohostSelector,
  eventTicketCountsSelector,
  ticketTypesSelector,
  usersSelector
} from 'src/selectors'
import {
  deleteInvitation,
  updateInvitation,
  invitations_activate,
  updateInvitationDelivery
} from 'src/actions/invitations'
import {
  PurchaseWorkflowNode,
  setCheckoutModalOpen,
  setDefaultWorkflowNode,
  setRequiredCredits
} from 'src/actions/stripeCheckout'
import { setInvitationsCount } from 'src/actions'
import PropTypes from 'prop-types'
import { arrayDeduplicationWithObject } from 'services/utils'
import debounce from 'lodash/debounce'
import moment from 'moment'
import PopConfirm from 'components/common/PopConfirm/PopConfirm'
import { getPlanTypeBySlug, PlanType } from 'src/services/stripe_checkout_configs'
import { isMobile } from 'services/browser_detection'

function withGuestsList(WrapperComponent) {
  class WithGuestsList extends Component {
    state = {
      selectedGuest: null,
      searchValue: '',
      searchGuestsList: [],
      guestsList: [],
      selectedTag: 'all',
      tags: ['all', 'yes', 'no', 'not replied', 'unsent'],
      isLimitEmailModalVisible: false,
      currentPlan: PlanType.Free
    }

    handleSelectTag = tag => {
      this.setState({
        selectedTag: tag,
        searchValue: '',
        searchGuestsList: []
      })
    }

    handleRemoveGuest = () => {
      this.props.onDeleteInvitation({
        eventId: this.props.event.id,
        invitationId: this.state.selectedGuest.id,
        onSuccessCallback: () => {
          this.setState({ selectedGuest: null })
          this.initialGuestsList()
        }
      })
    }

    handleEditGuest = params => {
      const { selectedGuest } = this.state
      let { first_name, last_name, cohost } = params
      const user = this.props.users[selectedGuest.guest]

      if (typeof first_name === 'undefined') {
        first_name = selectedGuest.first_name
      }

      if (typeof last_name === 'undefined') {
        last_name = selectedGuest.last_name
      }

      if (first_name === '' && last_name === '' && user) {
        first_name = user.first_name
        last_name = user.last_name
      }

      console.log(first_name, last_name, cohost)
      const invitation = {
        ...selectedGuest,
        first_name,
        last_name,
        cohost: typeof cohost === 'boolean' ? cohost : selectedGuest.cohost
      }

      this.props.onUpdateInvitation({
        eventId: this.props.event.id,
        invitationId: selectedGuest.id,
        invitation,
        onSuccessCallback: () => {
          this.setState({ selectedGuest: null })
          this.initialGuestsList()
        }
      })
    }

    handleSendHelpEmail = () => {
      if (this.state.currentPlan === PlanType.Free) {
        this.props.startMembershipPlanCheckout()
      } else {
        const aTag = document.createElement('a')
        aTag.href = process.env.BRANCH_INSTALL_BANNER_LINK
        aTag.click()
      }
      this.setState({ isLimitEmailModalVisible: false })
    }

    handleSendInvitations = () => {
      const {
        onSendInvitations,
        event,
        onUpdateInvitationDelivery,
        onSetInvitationsCount,
        checkout,
        userId,
        users
      } = this.props
      const { guestsList } = this.state
      const user = users[userId]

      window.mixpanel.track('INVITES Sent', { event_id: event.id, user_id: userId })

      const emailInvitations = guestsList.filter(
        item => item.contact_method.type === EMAIL_CONTACT_METHOD
      )

      if (emailInvitations.length > 100) {
        const currentSub = user.current_subscription
        const planType = getPlanTypeBySlug(currentSub?.plan?.slug)
        const planTypeFree = planType === PlanType.Free
        const planTypeInvitationMaker = planType === PlanType.InvitationMaker
        const limitCurrentPlan = planTypeFree || planTypeInvitationMaker

        if (limitCurrentPlan) {
          this.setState({ isLimitEmailModalVisible: true, currentPlan: planType })
          return
        }
      }

      onSendInvitations({
        eventId: event.id,
        onSuccessCallback: data => {
          const { estimated_cost, available_credit, sending_ids } = data

          if (sending_ids.length > 0) {
            onUpdateInvitationDelivery(sending_ids)
            const invitationsCount = this.props.activeInvitations.filter(
              item => item.delivery_state !== 'pending'
            ).length

            onSetInvitationsCount(invitationsCount)
            this.initialGuestsList(true)
          }

          if (available_credit < estimated_cost) {
            checkout(Number(estimated_cost) - Number(available_credit))
          }
        }
      })
    }

    searchGuestsDebounce = debounce(value => {
      const activeGuestsList = this.getGuestsList()

      const searchGuestsWithName = activeGuestsList.filter(({ first_name, last_name }) => {
        const fullName = first_name + ' ' + last_name
        return fullName?.toLowerCase()?.includes(value.toLowerCase())
      })

      const searchGuestsWithContactMethodDisplayName = activeGuestsList.filter(
        ({ contact_method_display_name }) => {
          return contact_method_display_name?.toLowerCase()?.includes(value.toLowerCase())
        }
      )

      const searchGuestsList = arrayDeduplicationWithObject(
        searchGuestsWithName.concat(searchGuestsWithContactMethodDisplayName),
        'id'
      )

      this.setState({ searchGuestsList: JSON.parse(JSON.stringify(searchGuestsList)) })
    }, 300)

    searchGuests = (value = this.state.searchValue) => {
      this.setState({ searchValue: value })

      if (!value) {
        this.setState({ searchGuestsList: [] })
        return
      }

      this.searchGuestsDebounce(value)
    }

    initialGuestsList = (isCheckUnsent = false) => {
      const { activeInvitations, eventTicketCounts, ticketTypes, onResetInvitationsPusher } =
        this.props

      onResetInvitationsPusher()

      let currentSelectedTag = this.state.selectedTag
      let sentGuests = activeInvitations.sort((a, b) => {
        if (moment(a.created_at).isAfter(moment(b.created_at))) return -1
      })

      if (eventTicketCounts.ticketing_enabled_at) {
        sentGuests = sentGuests.map(invitation => {
          const eventTicket = eventTicketCounts.invitations.find(item => item.id === invitation.id)
          if (eventTicket?.rsvp_state === 'accepted') {
            for (let ticket of eventTicket.ticket_counts) {
              const label = ticketTypes.find(
                ticketType => ticketType.id === ticket.ticket_type_id
              ).label
              if (label === 'adult') {
                invitation.guest_count = ticket.ticket_count
              }
              if (label === 'child') {
                invitation.child_count = ticket.ticket_count
              }
            }
          } else {
            invitation.guest_count = 0
            invitation.child_count = 0
          }

          return invitation
        })
      }

      if (isCheckUnsent) {
        const unSentInvitations = sentGuests.filter(item => item.delivery_state === 'pending')
        if (unSentInvitations.length > 0) {
          currentSelectedTag = 'unsent'
        } else {
          currentSelectedTag = currentSelectedTag === 'unsent' ? 'all' : currentSelectedTag
        }
      }

      this.setState({ guestsList: sentGuests, selectedTag: currentSelectedTag }, () => {
        this.searchGuests()
      })
    }

    getGuestsList = (tag = this.state.selectedTag) => {
      const { guestsList } = this.state
      switch (tag) {
        case 'all':
          return guestsList
        case 'yes':
          return guestsList.filter(invitation => invitation.rsvp_state === 'accepted')
        case 'no':
          return guestsList.filter(invitation => invitation.rsvp_state === 'declined')
        case 'unsent':
          return guestsList.filter(invitation => invitation.delivery_state === 'pending')
        case 'created':
          return guestsList.filter(i => i.delivery_state === 'pending' && i.created_at)
        case 'not replied':
          return guestsList.filter(
            i => i.rsvp_state === 'undecided' && i.delivery_state !== 'pending'
          )
        case 'failed':
          return guestsList.filter(
            i => i.delivery_state === 'delivery_failed' || i.delivery_state === 'delivery_aborted'
          )
      }
    }

    componentDidMount() {
      this.initialGuestsList(true)
    }

    componentDidUpdate() {
      // Receive pusher to change data.
      if (this.props.invitationsPusher.length > 0) {
        this.initialGuestsList()
      }
    }

    render() {
      const isFreePlan = this.state.currentPlan === PlanType.Free
      return (
        <>
          <WrapperComponent
            {...this.state}
            userId={this.props.userId}
            event={this.props.event}
            users={this.props.users}
            onChangeEventsModal={this.props.onChangeEventsModal}
            isHost={this.props.isHost}
            isHostOrCohost={this.props.isHostOrCohost}
            onInputChange={this.searchGuests}
            onGetGuestsList={this.getGuestsList}
            onSelectTag={this.handleSelectTag}
            onRemoveGuest={this.handleRemoveGuest}
            onEditGuest={this.handleEditGuest}
            onSelectGuest={guest => this.setState({ selectedGuest: guest })}
            onSendInvitations={this.handleSendInvitations}
          />

          <PopConfirm
            visible={this.state.isLimitEmailModalVisible}
            onClose={() => this.setState({ isLimitEmailModalVisible: false })}
            onConfirm={this.handleSendHelpEmail}
            confirmText={isFreePlan ? 'UPGRADE' : 'OPEN HOBNOB APP'}
            cancelText="No, thanks"
          >
            <div style={{ padding: '0 30px' }}>
              <h3>Upgrade</h3>
              <p style={{ fontSize: '15px', fontWeight: 400 }}>
                It seems that you are trying to send over 100 email invites.&nbsp;
                {isFreePlan
                  ? 'Upgrade to continue sending the invites.'
                  : 'Go to our iOS app to upgrade to continue sending the invites.'}
              </p>
            </div>
          </PopConfirm>
        </>
      )
    }
  }

  WithGuestsList.displayName = `WithGuestsList(${WrapperComponent.displayName})`
  WithGuestsList.propTypes = {
    userId: PropTypes.string,
    isHost: PropTypes.bool,
    isHostOrCohost: PropTypes.bool,
    activeInvitations: PropTypes.array,
    ticketTypes: PropTypes.array,
    invitationsPusher: PropTypes.array,
    eventTicketCounts: PropTypes.object,
    event: PropTypes.object,
    users: PropTypes.object,
    onChangeEventsModal: PropTypes.func,
    onResetInvitationsPusher: PropTypes.func,
    onDeleteInvitation: PropTypes.func,
    onUpdateInvitation: PropTypes.func,
    onSendInvitations: PropTypes.func,
    onUpdateInvitationDelivery: PropTypes.func,
    onSetInvitationsCount: PropTypes.func,
    checkout: PropTypes.func,
    startMembershipPlanCheckout: PropTypes.func
  }

  return connect(mapStateToProps, mapDispatchToProps)(WithGuestsList)
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeEventsModal: tab => dispatch(changeEventsModal(tab)),
    onResetInvitationsPusher: () => dispatch(resetInvitationsPusher()),
    onDeleteInvitation: params => dispatch(deleteInvitation(params)),
    onSendInvitations: params => dispatch(invitations_activate(params)),
    onUpdateInvitationDelivery: params => dispatch(updateInvitationDelivery(params)),
    onSetInvitationsCount: params => dispatch(setInvitationsCount(params)),
    startMembershipPlanCheckout: () => {
      let node
      if (isMobile()) {
        node = PurchaseWorkflowNode.PurchasePlanOnMobileApp
      } else {
        node = PurchaseWorkflowNode.UpgradePlan
      }
      dispatch(setDefaultWorkflowNode(node))
      dispatch(setCheckoutModalOpen(true))
    },
    checkout: credits => {
      dispatch(setRequiredCredits(credits))
      dispatch(setDefaultWorkflowNode(PurchaseWorkflowNode.Init))
      dispatch(setCheckoutModalOpen(true))
    },
    onUpdateInvitation: params =>
      dispatch(updateInvitation(params.invitation, params.invitationId, params.eventId, {}, params))
  }
}

function mapStateToProps(state) {
  return {
    event: eventSelector(state),
    invitationsPusher: state.frontend.invitationsPusher,
    isHost: isHostSelector(state),
    isHostOrCohost: isHostOrCohostSelector(state),
    activeInvitations: activeInvitationsSelector(state),
    eventTicketCounts: eventTicketCountsSelector(state),
    ticketTypes: ticketTypesSelector(state),
    users: usersSelector(state),
    userId: state.userId
  }
}

export default withGuestsList
